export function initAccordion() {
    // Find all accordion containers
    const accordionContainers = document.querySelectorAll('[role="region"][aria-label*="accordion"]');
    
    accordionContainers.forEach(container => {
        const accordionItems = container.querySelectorAll('.accordion-item');
        
        accordionItems.forEach(item => {
            const button = item.querySelector('button[aria-controls]');
            
            if (!button) return;
            
            const panelId = button.getAttribute('aria-controls');
            const panel = panelId ? document.getElementById(panelId) : null;
            
            // Skip if no panel exists (conditionally rendered content)
            if (!panel) return;
            
            // Check if this item should be active by default
            const isActive = item.dataset.accordionActive === 'true';
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            
            // Remove the hidden class and set initial state
            panel.classList.remove('hidden');
            panel.style.overflow = 'hidden';
            panel.style.transition = 'max-height 0.3s ease-out, opacity 0.3s ease-out';
            
            // Add transition to the accordion icon (plus/minus)
            const icon = button.querySelector('.accordion-icon');
            if (icon) {
                icon.style.transition = 'transform 0.3s ease-out';
            }
            
            // Set initial state based on isActive or isExpanded
            if (isActive || isExpanded) {
                panel.style.maxHeight = panel.scrollHeight + 'px';
                panel.style.opacity = '1';
                if (icon) {
                    icon.style.transform = 'rotate(45deg)';
                }
            } else {
                panel.style.maxHeight = '0';
                panel.style.opacity = '0';
            }
            
            button.addEventListener('click', () => {
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                
                // Toggle current item
                button.setAttribute('aria-expanded', !isExpanded);
                
                if (isExpanded) {
                    // Close - first set explicit height, then animate to 0
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                    
                    // Force reflow to ensure the height is set before animating
                    panel.offsetHeight;
                    
                    // Now animate to 0
                    requestAnimationFrame(() => {
                        panel.style.maxHeight = '0';
                        panel.style.opacity = '0';
                    });
                } else {
                    // Open - set to scrollHeight and fade in
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                    panel.style.opacity = '1';
                }
                
                // Rotate icon
                if (icon) {
                    if (isExpanded) {
                        icon.style.transform = 'rotate(0deg)';
                    } else {
                        icon.style.transform = 'rotate(45deg)';
                    }
                }
            });
        });
    });
}
